import config from '@/config';
import { fetchData } from '@/model/utils/fetch';

export const fetchShuffleGames = async ({
  authToken,
  title,
  locale,
  market_country,
  market_region,
  behaviour,
  limit,
  uid,
}: {
  authToken: string;
  title: string;
  locale?: string;
  market_country?: string;
  market_region?: string;
  behaviour?: string;
  limit?: string;
  uid?: string;
}) => {
  try {
    const res = await fetchData<{
      [key: string]: any;
    }>({
      url: `${config.urls.bffBaseUrl}/shuffle-games`,
      headers: { authorization: `Bearer ${authToken}` },
      queryParameters: {
        title,
        market_country,
        market_region,
        locale,
        base_path: config.base_path,
        behaviour,
        limit,
        uid,
      },
    });

    return {
      status: 200,
      data: res.games,
    };
  } catch (err) {
    console.error(
      `There was a problem while fetching Shuffle games. ${config.urls.bffBaseUrl}/shuffle-games.`
    );
    console.error(err);

    return {
      // @ts-ignore
      status: err.status,
      data: [],
    };
  }
};
